var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSynagogue(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.58704,
    height: 53.53442,
    viewBox: "0 0 56.58704 53.53442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4aa41;}.cls-2{fill:#fff;}.cls-3{fill:#a57939;}.cls-4{fill:#d0cfce;}.cls-5{fill:#3f3f3f;}.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-6,.cls-7{fill:none;stroke:#000;stroke-width:2px;}.cls-7{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.37425,27.31503v26.2194H11.37425V27.31503c0-.3181,.1513-.6173,.4076-.8057l15.9731-11.744c.3555-.3077,.8831-.3077,1.2386,0l15.9731,11.744c.2563,.1885,.4076,.4876,.4076,.8057Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.37425,
    y: 32.53442,
    width: 10,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.37425,
    y: 32.53442,
    width: 10,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.37425,53.53442h-8v-6c0-1.6569,1.3431-3,3-3h2c1.6569,0,3,1.3431,3,3v6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.37425 23.53442 45.37425 32.53442 55.37425 32.53442 50.37425 23.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "6.37425 23.53442 1.37425 32.53442 11.37425 32.53442 6.37425 23.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.37425 20.53442 19.71395 35.53442 37.03455 35.53442 28.37425 20.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.37425 40.53442 37.03455 25.53442 19.71395 25.53442 28.37425 40.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.37425 20.53442 19.71395 35.53442 37.03455 35.53442 28.37425 20.53442"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.37425,27.31503v26.2194H11.37425V27.31503c0-.3181,.1513-.6173,.4076-.8057l15.9731-11.744c.3555-.3077,.8831-.3077,1.2386,0l15.9731,11.744c.2563,.1885,.4076,.4876,.4076,.8057Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1.37425,
    y: 32.53442,
    width: 10,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 45.37425,
    y: 32.53442,
    width: 10,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.37425,53.53442h-8v-6c0-1.6569,1.3431-3,3-3h2c1.6569,0,3,1.3431,3,3v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.37425,40.53442h-2v-3c0-.5523,.4477-1,1-1h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.37425,40.53442h-2v-3c0-.5523,.4477-1,1-1h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 28.37425,
    y1: 53.53442,
    x2: 28.37425,
    y2: 44.53442
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "50.37425 23.53442 45.37425 32.53442 55.37425 32.53442 50.37425 23.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "6.37425 23.53442 1.37425 32.53442 11.37425 32.53442 6.37425 23.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.37425 20.53442 19.71395 35.53442 37.03455 35.53442 28.37425 20.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.37425 40.53442 37.03455 25.53442 19.71395 25.53442 28.37425 40.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.37425 20.53442 19.71395 35.53442 37.03455 35.53442 28.37425 20.53442"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.37425 40.53442 37.03455 25.53442 19.71395 25.53442 28.37425 40.53442"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynagogue);
export default __webpack_public_path__ + "static/media/synagogue.87c78bc06c7ead77157d2f4b546ac120.svg";
export { ForwardRef as ReactComponent };